import './Demo.css';

const CONVERSATION = [
  {
    role: 'user',
    content: 'What powers the AM3358 processor core on the BeagleBone?',
  },
  {
    role: 'assistant',
    content: `I'll trace the VDD_CORE rail to find out.`,
    toolCall: {
      name: 'query_xnet_by_net_name',
      args: 'net_name: "VDD_CORE", skip_types: ["C", "L"]',
    },
    toolResult: `Found 2 components on VDD_CORE:
• U2 (TPS65217C) pin 29 → PMIC DCDC output
• U5 (AM3358) pins F6, F7, G6... (20 pins)
Skipped: 18 capacitors, 1 inductor`,
    responseHtml: (
      <>
        The AM3358 core is powered by <strong>U2</strong>, a <strong>TPS65217C</strong> PMIC. The
        DCDC3 output (pin 29) delivers VDD_CORE to 20 power pins on the processor, with bulk
        decoupling via 18 capacitors and a ferrite bead for filtering.
      </>
    ),
  },
  {
    role: 'user',
    content: 'Is there ESD protection on USB0?',
  },
  {
    role: 'assistant',
    content: `Let me trace the USB0 data lines.`,
    toolCall: {
      name: 'query_xnet_by_net_name',
      args: 'net_name: "USB0_DP"',
    },
    toolResult: `Found 3 components:
• U5 (AM3358) pin N17
• P4 (USB5MINI) pin 3
• U10 (TPD4S012) pin 1`,
    responseHtml: (
      <>
        Yes — <strong>U10</strong> is a <strong>TPD4S012</strong> providing ESD protection. It sits
        between the USB mini connector (P4) and the AM3358, protecting D+, D-, ID, and VBUS lines.
      </>
    ),
  },
];

/**
 * Demo section showing a realistic AI conversation using netlist tools.
 */
export function Demo() {
  return (
    <section id="demo" className="section demo">
      <div className="container">
        <header className="section-header">
          <h2>
            See It <span className="gradient-text">In Action</span>
          </h2>
          <p>A real conversation analyzing the BeagleBone Black schematic.</p>
        </header>

        <div className="demo-conversation">
          {CONVERSATION.map((msg, index) => (
            <div key={index} className={`demo-message demo-message-${msg.role}`}>
              <div className="demo-message-header">
                <span className="demo-role">{msg.role === 'user' ? 'Engineer' : 'AI Agent'}</span>
              </div>
              <div className="demo-message-content">
                <p>{msg.content}</p>

                {msg.toolCall && (
                  <div className="demo-tool-call">
                    <div className="demo-tool-header">
                      <span className="demo-tool-icon">⚡</span>
                      <code>{msg.toolCall.name}</code>
                    </div>
                    <pre className="demo-tool-args">{msg.toolCall.args}</pre>
                  </div>
                )}

                {msg.toolResult && (
                  <div className="demo-tool-result">
                    <div className="demo-tool-header">
                      <span className="demo-tool-icon">↩</span>
                      <span>Result</span>
                    </div>
                    <pre className="demo-tool-output">{msg.toolResult}</pre>
                  </div>
                )}

                {msg.responseHtml && <p className="demo-response">{msg.responseHtml}</p>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
